<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_1"></a>Tropic Death</h1>
<p class="author-title">Eric Walrond</p>
<p class="centerimg"><img alt="image" class="Title Page" src="images/logo.jpg"/><a id="page_2"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Titlepage.vue?1b8b6cd6